import React from 'react';

import PropTypes from 'prop-types';
import EditButton from '../edit';
import DeleteButton from '../delete';

import { BlockItemContainer, BlockItemHead, BlockTitle } from '../../css';
import FormControlPanel from '../formControlPanel';

const BlockItem = ({ data, fetchData }) => {
  const { id, name, formTypes } = data;
  return (
    <BlockItemContainer>
      <BlockItemHead>
        <BlockTitle>{name}</BlockTitle>
        <div style={{ display: 'flex' }}>
          <EditButton id={id} name={name} fetchData={fetchData} />
          <DeleteButton id={id} name={name} fetchData={fetchData} />
        </div>
      </BlockItemHead>
      <FormControlPanel id={id} formTypes={formTypes} fetchData={fetchData} />
    </BlockItemContainer>
  );
};

BlockItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    formTypes: PropTypes.shape({
      disableBrp: PropTypes.bool,
      disableReferral: PropTypes.bool,
      disableWireless: PropTypes.bool,
      disableWireline: PropTypes.bool
    })
  }).isRequired,
  fetchData: PropTypes.func.isRequired
};

export default BlockItem;
